import { makeStyles } from '@material-ui/core/styles'
import { IStyleProps } from './Interface'

const height = (rows: number | string, textSize: number) => (rows >= 5 ? 5 : (rows as number)) * (textSize + 4)

const getPaddingRightInputWithCounter = (showCounter: boolean, limit: number) => {
  return showCounter && limit && `${limit}`.length > 1 ? 12 * `${limit}`.length : 14
}

export default makeStyles<{}, IStyleProps>({
  input: ({ alwaysEnabled, multiline, rows, textSize, showCounter, limit, textColor, disabled }) => ({
    width: '100%',
    color: textColor,
    borderRadius: multiline ? height(rows, textSize) / 6 : 40,
    boxSizing: 'border-box',
    backgroundColor: '#FFFFFF',
    height: multiline ? height(rows, textSize) : '35px',
    fontSize: 12,
    '& .MuiOutlinedInput-input': {
      cursor: alwaysEnabled ? 'text' : 'pointer',
      paddingRight: getPaddingRightInputWithCounter(showCounter, limit)
    },
    ...(alwaysEnabled
      ? {}
      : {
          '&:hover:not(:focus-within)': !!disabled
            ? {}
            : {
                backgroundColor: '#EDEBEB'
              },
          '& .MuiOutlinedInput-input:not(:focus) + .MuiOutlinedInput-notchedOutline': {
            border: 'none'
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'transparent'
          },
          '&:hover:not(.Mui-focused) .MuiOutlinedInput-notchedOutline': {
            borderColor: 'transparent'
          },
          '& .MuiFormLabel-root': {
            display: 'none'
          },
          '&:hover .MuiFormLabel-root': {
            display: 'inherit'
          },
          '&.Mui-focused .MuiFormLabel-root': {
            display: 'inherit'
          }
        })
  }),
  container: {
    flex: 1,
    display: 'flex',
    position: 'relative',
    alignItems: 'flex-end',
    flexDirection: 'column',
    justifyContent: 'flex-end'
  },
  counter: {
    fontSize: 9,
    position: 'absolute',
    right: 10,
    bottom: 11
  },
  display: {
    wordBreak: 'break-word',
    color: ({ textColor }) => textColor,
    margin: 0,
    lineHeight: 1,
    fontSize: ({ textSize }) => textSize,
    borderRadius: 40,
    boxSizing: 'border-box',
    minWidth: 150,
    minHeight: 35,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 0,
    fontWeight: 500,
    paddingTop: 10
  },
  hover: ({ disabled }) => ({
    '&:hover': !!disabled
      ? {}
      : {
          background: '#EDEBEB',
          transition: '.3s'
        }
  }),
  placeholder: {
    opacity: '0.4'
  }
})
